import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';

import { BreakpointService } from '../breakpoint/breakpoint.service';

import { BreakpointKey } from './../helpers/css-utils';

export function isInteractiveElement(element: Element): boolean {
  return ['A', 'BUTTON', 'INPUT', 'TEXTAREA', 'LABEL'].includes(element.tagName);
}

@Directive({
  selector: `[shrdUtcConditionalClick]`
})
export class ConditionalClickDirective {
  /* Inputs */
  @Input() triggerOnInteractiveTargets = true;
  @Input() triggerMaxBreakpoint?: BreakpointKey;
  @Input() triggerMinBreakpoint?: BreakpointKey;

  /* Outputs */
  @Output() shrdUtcConditionalClick = new EventEmitter();

  /* Host Listener */
  @HostListener('click', ['$event']) onClick(event: Event) {
    /* Only emit click event when all specified requirements were met */
    if (this.shouldEmitClick(event)) {
      this.shrdUtcConditionalClick.emit(event);
    }
  }

  constructor(private readonly breakpointService: BreakpointService) {}

  private shouldEmitClick(event: Event): boolean {
    return (
      this.eventTargetIsInteractive(event) &&
      this.breakpointService.isWithinBreakpoints(this.triggerMinBreakpoint, this.triggerMaxBreakpoint)
    );
  }

  private eventTargetIsInteractive(event: Event): boolean {
    /* Check if interactive element checking is enabled, then check if event target is interactive Element */
    return this.triggerOnInteractiveTargets || !isInteractiveElement(event.target as Element);
  }
}
